import { render } from "./TkCaseNoteCard.vue?vue&type=template&id=1c86a0dc&scoped=true"
import script from "./TkCaseNoteCard.vue?vue&type=script&lang=js"
export * from "./TkCaseNoteCard.vue?vue&type=script&lang=js"

import "./TkCaseNoteCard.vue?vue&type=style&index=0&id=1c86a0dc&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c86a0dc"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QBtn});
